import { useCallback } from "react";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { PinIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import { useCurrentUser } from "utils/currentUser";
import util from "utils/utils";

import PinIdeaHelper from "../../PinIdeaHelper";
import type { IdeaWithOwnerChallenge } from "../types";

type PinActionProps = { idea: IdeaWithOwnerChallenge };

const PinAction = ({ idea }: PinActionProps) => {
  const user = useCurrentUser();
  const { t } = useTranslation();
  const ideaId = idea?._id;

  const pinIdea = useCallback(() => {
    api.ideas.updateStatus(
      ideaId,
      { isPinned: !idea?.isPinned },
      (ideaStatus) => {
        util.onUpdateIdea(idea, { isPinned: ideaStatus.isPinned });
      },
      (err) => toast.error(err.message),
    );
  }, [ideaId, idea]);

  if (!util.canManageChallenge(user!, idea.ownerChallenge)) {
    return null;
  }
  if (!util.hasPermission(user!, "challenge.pinIdeas", idea.challenge)) {
    return null;
  }
  return (
    <Button
      onClick={pinIdea}
      tooltip={
        <div>
          <b>
            {idea?.isPinned
              ? `Un-pin ${t("generic.idea")}`
              : `Pin ${t("generic.idea")}`}
          </b>
          <PinIdeaHelper challenge={idea.ownerChallenge!} />
        </div>
      }
    >
      <Icon
        icon={PinIcon}
        style={{ transform: idea?.isPinned ? "rotate(45deg)" : "rotate(0deg)" }}
      />
    </Button>
  );
};

export default PinAction;
